import { useAxios } from "@hooks"
import { AIGradingAnalysis } from "@types";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch the most recent AI grading analysis for a question
 * @param examInstanceQuestionId - The question ID to get analysis for
 * @returns Query hook with AI analysis data
 */
export const useGetAIAnalysis = (examInstanceQuestionId?: string) => {
    const axios = useAxios();

    const getAIAnalysis = async (): Promise<AIGradingAnalysis | null> => {
        try {
            const response = await axios.get<AIGradingAnalysis>(
                `/api/ExamInstanceQuestion/${examInstanceQuestionId}/ai-analysis`
            );
            return response.data;
        } catch (error: any) {
            // 404 means no analysis exists yet - this is not an error
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    };

    return useQuery({
        queryKey: ["aiAnalysis", examInstanceQuestionId],
        queryFn: getAIAnalysis,
        enabled: !!examInstanceQuestionId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: (failureCount, error: any) => {
            // Don't retry on 404
            if (error.response?.status === 404) return false;
            return failureCount < 2;
        }
    });
};
